export class DateFieldParameter {
  future: boolean | undefined;

  constructor() {
    this.future = false;
  }
}
